import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  cursor: pointer;
  background-color: #f6f7fb;
`;

export const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;
